/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSocialIcons_viewer = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSocialIcons_viewer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PinterestPinIcon_viewer",
      "args": null
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/social/__generated__/PdpSocialIcons_viewer.graphql.js